import {request} from '../jslib/request'
const BASE_REQUEST = '/tms/sysCustomerSecondlevel'
const BASE_REQUEST_ONE_SECOND = '/tms/sysCustomerOneSecond'
const BASE_REQUEST_SECOND_RECEIVE = '/tms/sysCustomerSecondReceive'



export function getAllCusTomer() {
    return request({
        url:`${BASE_REQUEST}/getAllCusTomer`
    })
}

/** 根据公司名称进行模糊查询 */
export function getNameLikeList(data) {
    return request({
        url:`${BASE_REQUEST}/getNameLikeList`,
        method: 'get',
        data
    })
}

export function getAllCusTomerCode() {
  return request({
    url:`${BASE_REQUEST}/getAllCusTomerCode`
  })
}

export function getSysCustomerlxrList(invoiceId) {
    return request({
        url:`${BASE_REQUEST}/getSysCustomerlxrList`,
        data: {
            invoiceId:invoiceId
        }
    })
}
export function getSysCustomerSecondlevelList(querydata) {
        return request({
            url:`${BASE_REQUEST}/getSysCustomerSecondlevelList`,
            data:querydata
        })
}
export function getSysCustomerSecondlevelInfoById(id) {
        return request({
            url:`${BASE_REQUEST}/getSysCustomerSecondlevelInfoById`,
            data: {'id':id}
        })
}

export function updateSysCustomerSecondlevel(
    obj
) {
    return request({
        url:`${BASE_REQUEST}/updateSysCustomerSecondlevel`,
        data:obj
    })
}

export function delSysCustomerSecondlevel(
    id
) {
    return request({
        url:`${BASE_REQUEST}/delSysCustomerSecondlevel`,
        data:{id: id}
    })
}

export function modLxr(
    obj
) {
    return request({
        url:`${BASE_REQUEST}/modLxr`,
        data:obj
    })
}

export function delLxr(
    id
) {
    return request({
        url:`${BASE_REQUEST}/delLxr`,
        data:{id: id}
    })
}
export function saveLxr(
    obj
) {
    return request({
        url:`${BASE_REQUEST}/saveLxr`,
        data:obj
    })
}
export function saveSysCustomerSecondlevel(
    obj
) {
    return request({
        url:`${BASE_REQUEST}/saveSysCustomerSecondlevel`,
        data:obj
    })
}


export function getCustomerList(querydata) {
  return request({
    url:`${BASE_REQUEST}/getCustomerList`,
    data:querydata
  })
}

export function updateMongoRemark(querydata) {
  return request({
    url:`${BASE_REQUEST}/updateMongoRemark`,
    data:querydata
  })
}

export function getMongoRemark(querydata) {
  return request({
    url:`${BASE_REQUEST}/getMongoRemark`,
    data:querydata
  })
}

export function getOneSecond(id) {
  return request({
    url:`${BASE_REQUEST_ONE_SECOND}/getOneSecond`,
    data:{id:id}
  })
}

export function saveOneSecond(list) {
  return request({
    url:`${BASE_REQUEST_ONE_SECOND}/saveOneSecond`,
    data:{list:list}
  })
}

export function getSecondReceive(id) {
  return request({
    url:`${BASE_REQUEST_SECOND_RECEIVE}/getSecondReceive`,
    data:{id:id}
  })
}

export function saveSecondReceive(list) {
  return request({
    url:`${BASE_REQUEST_SECOND_RECEIVE}/saveSecondReceive`,
    data:{list:list}
  })
}
